import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28b1fc8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=28b1fc8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1fc8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b1fc8c')) {
      api.createRecord('28b1fc8c', component.options)
    } else {
      api.reload('28b1fc8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28b1fc8c&scoped=true", function () {
      api.rerender('28b1fc8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contracts/index.vue"
export default component.exports